module.exports = __webpack_public_path__ + "static/paul.ecd3ed17.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/paul.jpg
// module id = 141
// module chunks = 0